export default __webpack_public_path__ + "static/media/audio-2.25fa79bc.wav";